import React from 'react';

import { SecureRoute } from '@okta/okta-react';

const GGSecurityRoute = ({ children, ...props }: any) => {
  return <SecureRoute {...props}>{children}</SecureRoute>;
};
export default GGSecurityRoute;
